import { ApplicationConfig } from "@angular/core";
import { provideRouter, withComponentInputBinding } from "@angular/router";
import { MessageService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import Lara from "@primeuix/themes/lara";
import { definePreset } from "@primeuix/themes";
import { routes } from "./app/app.routes";

const CyberaTheme = definePreset(Lara, {
  semantic: {
    primary: {
      50: "{zinc.50}",
      100: "{zinc.100}",
      200: "{zinc.200}",
      300: "{zinc.300}",
      400: "{zinc.400}",
      500: "{zinc.500}",
      600: "{zinc.600}",
      700: "{zinc.700}",
      800: "{zinc.800}",
      900: "{zinc.900}",
      950: "{zinc.950}",
    },
    colorScheme: {
      light: {
        primary: {
          color: "{zinc.950}",
          contrastColor: "#ffffff",
          hoverColor: "{zinc.800}",
          activeColor: "{zinc.600}",
        },
        highlight: {
          background: "{zinc.950}",
          focusBackground: "{zinc.700}",
          color: "#ffffff",
          focusColor: "#ffffff",
        },
      },
      dark: {
        primary: {
          color: "{zinc.50}",
          contrastColor: "{zinc.950}",
          hoverColor: "{zinc.100}",
          activeColor: "{zinc.200}",
        },
        highlight: {
          background: "rgba(250, 250, 250, .16)",
          focusBackground: "rgba(250, 250, 250, .24)",
          color: "rgba(255,255,255,.87)",
          focusColor: "rgba(255,255,255,.87)",
        },
      },
    },
  },
  components: {
    chip: {
      root: {
        background: "#dee2e6",
        color: "#262626",
      },
    },
    tooltip: { root: { padding: "0.50rem" } },
    tabs: {
      tablist: { borderWidth: "0 0 1px 0", borderColor: "{zinc.200}" },
      tab: {
        background: "transparent",
        color: "{zinc.500}",
        borderWidth: "0 0 1px 0",
        borderColor: "{zinc.200}",
        hoverBorderColor: "{zinc.400}",
        activeBorderColor: "{zinc.950}",
        gap: "0.5rem",
        fontWeight: "600",
      },
    },
    image: {
      preview: { mask: { color: "{zinc.950}" } },
    },
    breadcrumb: { root: { padding: "12px 16px" } },
    button: {
      css: () => `
      .p-button:hover:not([disabled]) {
        box-shadow: var(--p-button-raised-shadow);
      }
      .p-button[disabled] {
        cursor: not-allowed;
      }
      `,
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    MessageService,
    providePrimeNG({
      theme: {
        preset: CyberaTheme,
        options: {
          prefix: "p",
          darkModeSelector: ".dark-mode",
          cssLayer: {
            name: "primeng",
            order: "theme, base, primeng, application",
          },
        },
      },
    }),
  ],
};
